(() => {
  const productId = '15457902133380';
  const markerSelector = `[data-afz-legend-product-id="${productId}"]`;
  const instanceKey = `afzProductLegendSync${productId}`;
  window[instanceKey]?.();
  const marker = document.querySelector(markerSelector);
  if (!marker) return;

  const scope = marker.closest('main') || document.body;
  const controller = new AbortController();
  let frame = 0;
  let stopped = false;
  let mediaGeneration = 0;
  const observer = new MutationObserver(schedule);

  function ownsPicker(picker) {
    if (!scope.contains(picker) || picker.closest('product-card, product-recommendations, quick-add, quick-add-modal')) return false;
    const owner = picker.closest('[data-product-id]');
    return !owner || owner.dataset.productId === productId;
  }

  import('@shopify/events').then(({ StandardEvents }) => {
    if (stopped) return;
    scope.addEventListener(StandardEvents.productSelect, (event) => {
      const picker = event.target.closest?.('variant-picker');
      if (!picker || !ownsPicker(picker) || typeof event.promise?.then !== 'function') return;
      const generation = ++mediaGeneration;
      event.promise.then(({ detail }) => {
        if (stopped || !detail?.html || (detail.productId && String(detail.productId) !== productId)) return;
        const gallery = detail.html.querySelector(`media-gallery[data-afz-product-id="${productId}"]`);
        const index = Number(gallery?.dataset.afzVariantMediaIndex);
        if (!gallery || !Number.isInteger(index) || index < 0) return;
        const incomingSlideshow = gallery.querySelector('slideshow-component');
        incomingSlideshow?.querySelectorAll('slideshow-slide').forEach((slide, slideIndex) => {
          slide.setAttribute('slide-id', `afz-${productId}-${slideIndex}`);
        });
        incomingSlideshow?.setAttribute('initial-slide', String(index));
        requestAnimationFrame(() => {
          if (stopped || generation !== mediaGeneration) return;
          const slideshow = scope.querySelector(`media-gallery[data-afz-product-id="${productId}"] slideshow-component`);
          slideshow?.select?.(index, undefined, { animate: false });
          const scroller = slideshow?.querySelector('[ref="scroller"]');
          const slide = slideshow?.querySelectorAll('slideshow-slide')[index];
          if (scroller && slide) {
            const offset = slide.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
            if (Math.abs(offset) > 1) scroller.scrollTo({ left: scroller.scrollLeft + offset, behavior: 'instant' });
          }
        });
      }).catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[AFZ product media]', error);
      });
    }, { capture: true, signal: controller.signal });
  }).catch((error) => {
    if (!stopped) console.warn('[AFZ product media events]', error);
  });

  function setUnitPrice(node, amount, bundle) {
    if (!node) return;
    const value = amount === null ? '—' : bundle.money(amount);
    let number = node.querySelector('[data-afz-unit-price]');
    if (!number) {
      number = document.createElement('span');
      number.dataset.afzUnitPrice = '';
      const unit = document.createElement('small');
      unit.dataset.afzUnitLabel = '';
      unit.textContent = ' /ea';
      unit.setAttribute('aria-hidden', 'true');
      node.replaceChildren(number, unit);
    }
    if (number.textContent !== value) number.textContent = value;
    const label = `${value} per item`;
    if (node.getAttribute('aria-label') !== label) node.setAttribute('aria-label', label);
  }

  function syncBundlePrices() {
    scope.querySelectorAll(`afz-bundle-selector[data-product-id="${productId}"]`).forEach((bundle) => {
      if (typeof bundle.totals !== 'function' || !bundle.picks || !bundle.config || !bundle.currency) return;
      bundle.querySelectorAll('[data-tier]').forEach((tier) => {
        const count = Number(tier.dataset.tier);
        if (!Number.isInteger(count) || count < 1) return;
        if (Number.isInteger(bundle.quantity)) {
          const selected = count === bundle.quantity;
          const radio = tier.querySelector('input[type="radio"]');
          if (radio && radio.checked !== selected) radio.checked = selected;
          if (tier.classList.contains('is-selected') !== selected) tier.classList.toggle('is-selected', selected);
          const content = tier.querySelector('[data-tier-content]');
          const hidden = !selected || count === 1;
          if (content && content.hidden !== hidden) content.hidden = hidden;
        }
        const totals = bundle.totals(count);
        const compare = totals ? (totals.compareAtPrice ?? totals.base) : 0;
        const price = tier.querySelector('[data-tier-total]');
        const base = tier.querySelector('[data-tier-base]');
        const saving = tier.querySelector('[data-tier-saving]');
        const tierConfig = bundle.config.tiers?.find((item) => Number(item.quantity) === count);
        const benefitText = (tierConfig?.description || tierConfig?.subtitle || '').trim();
        const benefit = tier.querySelector('[data-tier-benefit]');
        if (benefit && benefitText && benefit.textContent !== benefitText) benefit.textContent = benefitText;
        setUnitPrice(price, totals ? Math.round(totals.total / count) : null, bundle);
        if (base) {
          setUnitPrice(base, totals ? Math.round(compare / count) : null, bundle);
          base.hidden = !totals || compare <= totals.total;
        }
        const detail = count > 1 && totals
          ? `Total: ${bundle.money(totals.total)} for ${count} items · Save ${bundle.money(compare - totals.total)} vs. regular price`
          : '';
        if (saving && saving.textContent !== detail) saving.textContent = detail;
      });
    });
  }

  function sync() {
    frame = 0;
    if (!document.querySelector(markerSelector)) return destroy();
    scope.querySelectorAll('variant-picker').forEach((picker) => {
      if (!ownsPicker(picker)) return;
      picker.querySelectorAll('fieldset[data-fieldset-index]').forEach((fieldset) => {
        const label = fieldset.querySelector('legend .variant-option__swatch-value');
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        const selected = fieldset.querySelector('select')?.selectedOptions[0];
        const value = checked?.value || selected?.label?.trim();
        if (label && value && label.textContent.trim() !== value) label.textContent = value;
      });
    });
    syncBundlePrices();
    observer.takeRecords();
  }

  function schedule() {
    if (!stopped && !frame) frame = requestAnimationFrame(sync);
  }

  function destroy() {
    stopped = true;
    controller.abort();
    observer.disconnect();
    cancelAnimationFrame(frame);
    if (window[instanceKey] === destroy) delete window[instanceKey];
  }

  scope.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-afz-open-fit]');
    if (!link || !scope.contains(link)) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target instanceof HTMLDetailsElement && scope.contains(target)) target.open = true;
  }, { signal: controller.signal });
  document.addEventListener('change', (event) => {
    const picker = event.target.closest?.('variant-picker');
    if (picker && ownsPicker(picker)) schedule();
  }, { capture: true, signal: controller.signal });
  document.addEventListener('shopify:section:load', schedule, { signal: controller.signal });
  document.addEventListener('shopify:section:unload', (event) => {
    const currentMarker = document.querySelector(markerSelector);
    if (currentMarker && event.target.contains(currentMarker)) destroy();
  }, { signal: controller.signal });
  window.addEventListener('pagehide', (event) => {
    if (!event.persisted) destroy();
  }, { signal: controller.signal });
  window.addEventListener('pageshow', schedule, { signal: controller.signal });
  window.addEventListener('popstate', schedule, { signal: controller.signal });
  window.addEventListener('hashchange', schedule, { signal: controller.signal });
  observer.observe(scope, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'selected', 'data-current-checked']
  });
  window[instanceKey] = destroy;
  customElements.whenDefined('afz-bundle-selector').then(schedule);
  schedule();
})();
